import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
import "./App.css";
import Layout from "./components/layout";
import Uploader from "./components/upload";
import Video from "./components/video";
import Login from "./components/login";
import { useToken } from "./components/hooks";

zhCN.Upload.downloadFile = "点击下载二维码";

function App() {
  const { token, setToken, removeToken } = useToken();

  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Switch>
          <Route path="/admin">
            {!token ? (
              <Redirect to="/login" />
            ) : (
              <Layout showLogout={true} removeToken={removeToken}>
                <Uploader token={token} removeToken={removeToken} />
              </Layout>
            )}
          </Route>
          <Route path="/login">
            <Layout>
              <Login setToken={setToken} />
            </Layout>
          </Route>
          <Route path="/:id">
            <Video />
          </Route>
          <Route exact path="/">
            {!token ? <Redirect to="/login" /> : <Redirect to="/admin" />}
          </Route>
        </Switch>
      </Router>
    </ConfigProvider>
  );
}

export default App;
